<template>
	<tr v-if="isTitle" :class="rowClass" class="boldCell width100p bottomLine">
		<td colspan="2">
			<sym-icon :name="data.definition.icon" />
			&nbsp;
			{{msg(data.definition.resource)}}
		</td>
	</tr>
	<tr v-else :class="rowClass">
		<td>
			<label>
			<input type="checkbox" v-model="model.checkBoxes[property]" />
			&nbsp;
			{{msg(data.definition.resource)}}:
			</label>
		</td>
		<td>
			<consolidable-result v-model="model" :conflict="false" />
		</td>	
	</tr>
</template>

<script setup lang="ts">
	import {ref, computed, provide, watch} from "vue";
	import ConsolidableResult from "./ConsolidableResult.vue";
	import {msg} from "@/i18n/Message";
	import usePart from "@/fd/Part";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const props = defineProps<{
		data: ConsolidableDataItem,
		index: number
	}>();
	const model = defineModel();

	const rowClass = computed<string>(() => {
		return props.index % 2 === 0 ? "oddrow" : "evenrow";
	});
	
	const isTitle = computed<boolean>(() => {
		return props.data.definition.type==='TITLE';
	});
	
	const property = computed<boolean>(() => {
		return props.data.definition.property;
	});
	
	provide('definition', props.data.definition);
	
	watch(() => model.value[property.value], () => {
		//console.log("changed:"+property.value);
		model.value.checkBoxes[property.value]=true; 
	});
	
	//console.log("ROW:"+JSON.stringify(props.data));
</script>

